const initialState = {
  info: {},
  courses: []
};


export default (state = initialState, action) => {
  switch (action.type) {

  case 'GET_COURSES_INFO':
    return {
      ...state,
      info: action.payload
    };

  case 'GET_COURSES':
    return {
      ...state,
      courses: action.payload
    };

  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/coursesReducer.js